import {
  ORDER_RECEIVE,
  ORDER_ERROR,
  ORDER_CHANGE_MODE,
  ORDER_CHANGE_CURRENTPAGE,
  ORDER_SET_ORDER,
  ViewMode,
  ORDER_SET_IS_LOADING,
  ORDER_SET_SEARCH_WORD,
  ORDER_SET_FROM_DATE,
  ORDER_SET_TO_DATE,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  mode: ViewMode.List,
  list: [],
  order: {},
  totalCount: 0,
  errors: {},
  isOrdersLoading: false,
};

export const order = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ORDER_RECEIVE:
    case ORDER_CHANGE_MODE:
    case ORDER_CHANGE_CURRENTPAGE:
    case ORDER_SET_ORDER:
    case ORDER_SET_IS_LOADING:
    case ORDER_SET_SEARCH_WORD:
    case ORDER_SET_FROM_DATE:
    case ORDER_SET_TO_DATE:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case ORDER_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
